import { ConsentId } from '@/shared/enums';
import { Deferred } from '@/shared/libs';
import { AssetLoader } from '@/shared/utils';

export default ({ $deferredLoader, $oneTrust }, inject) => {
  $deferredLoader.smartad = new Deferred();

  const updateSmartAdParams = () => {
    const screenWidth = document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
    const screenHeight = document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    const os = navigator.platform;
    const refurl = encodeURIComponent(document.referrer || '');
    const pageurl = encodeURIComponent(document.URL || '');
    const rnd = new Date().getTime();

    window._smartad.pageId = Math.floor(Math.random() * 10000001);
    window._smartad.prop = `screen_width=${screenWidth}&screen_height=${screenHeight}&os=${os}&refurl=${refurl}&pageurl=${pageurl}&rnd=${rnd}`;
    window._smartad.type = 'onload';
  };

  inject('smartad', {
    load(spaceId) {
      return $deferredLoader.smartad.promise
        .then(() => {
          if (!$oneTrust.areConsentsAccepted([ConsentId.SMART_AD, ConsentId.TARGETING])) {
            return Promise.reject();
          }

          if (window._smartad[spaceId]) {
            window._smartad.reload(spaceId);
            return;
          }

          updateSmartAdParams();

          return new AssetLoader().load([
            { id: spaceId, src: `//serving.bepolite.eu/script?space=${spaceId}&type=direct&page_id=${window._smartad.pageId}&${window._smartad.prop}` },
          ], { async: true });
        })
        .catch(() => {});
    },
  });

  window._smartad = window._smartad || {};

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => $deferredLoader.smartad.resolve());
};
